import { styled } from '@mui/material';

export const OlStyled = styled('ol')(({ theme }) => ({
  'li::marker': {
    display: 'block',
    fontSize: theme.fonts.utility.size(9),
  },
}));
